<template>
  <router-view />
</template>

<script>
export default {
  name: "GeneralContents",
};
</script>
